import React from "react";

 import CasualGames from "../../components/casual-games";
import LotteryGames from "../../components/lottery-games";
import CrapsGames from "../../components/craps-games";
import FishingGames from "../../components/fishing-games";
import MinesGames from "../../components/mines-games";
import VirtualSportsGames from "../../components/virtual-sport-games";
import ScratchGames from "../../components/scratch-games";
import ProviderSlide from "../../components/providers-slide";
import SearchResults from "../casino-group/search-results";


const ExclusiveGamesPage = () => {

    return (
        <>


            <div className="section section--first">
                <SearchResults/>
            </div>

            <CasualGames/>
            <LotteryGames/>
            <CrapsGames/>
            <FishingGames/>


            <MinesGames/>
            <VirtualSportsGames/>
            <ScratchGames/>
            <ProviderSlide type={'exclusive'}/>
        </>

    )

}

export default ExclusiveGamesPage
